var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3533 8.35396L5.35333 14.354C5.25599 14.4513 5.12797 14.5006 4.99997 14.5006C4.87197 14.5006 4.74396 14.452 4.64662 14.354C4.45129 14.1586 4.45129 13.8419 4.64662 13.6466L10.2933 7.99996L4.64662 2.35331C4.45129 2.15797 4.45129 1.84128 4.64662 1.64595C4.84196 1.45062 5.15865 1.45062 5.35398 1.64595L11.354 7.64595C11.5486 7.84195 11.5487 8.15863 11.3533 8.35396Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.a49824e7.svg";
export { ForwardRef as ReactComponent };